export type CampaignQuoteSectionModel = {
  cache_key?: number,
  campaign_quote_id?: number,
  footer?: string,
  header?: string,
  hide_dates?: boolean,
  hide_prices?: boolean,
  id?: number,
  locked?: boolean,
  options?: any,
  show_subtotal?: boolean,
  sort?: number,
  title?: string,
  type?: 'CampaignQuoteSection',
}

export type CampaignQuoteSectionRequestOptions = {}

const state = {
  campaign_quote_id: undefined,
  footer: undefined,
  header: undefined,
  hide_dates: false,
  hide_prices: false,
  id: undefined,
  locked: false,
  show_subtotal: false,
  sort: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'campaign_quote_id' },
  { key: 'title' },
]

export default state
